import { AutogenModelEdiCrossRef, AutogenRowEdiCrossRef } from "./autogen/AutogenModelEdiCrossRef";

export class ModelEdiCrossRef extends AutogenModelEdiCrossRef<RowEdiCrossRef> {
	constructor() {
		super(RowEdiCrossRef);
	}
}

export class RowEdiCrossRef extends AutogenRowEdiCrossRef {
}